import styled from 'styled-components';
import InlineSVG from 'svg-inline-react';

export const SearchBarContainer = styled.div`
  display: flex;
  justify-content: left;
  border-bottom: ${props => props.theme.colors.capsuleGreen60} ${props => props.theme.space['0.1']} solid !important;
  padding-top: ${props => (props.theme.mediaQueries.mediumDown ? props.theme.space['1.0'] : '0')} !important;
  /* For safari, search bar needs more padding for the category scroll bar to render into */
  @media not all and (min-resolution: 0.001dpcm) {
    @supports (-webkit-appearance: none) {
      padding-top: ${props => (props.theme.mediaQueries.mediumDown ? props.theme.space['2.0'] : '0')} !important;
    }
  }
  &:focus-within {
    margin-bottom: ${props => `-${props.theme.space['0.1']}`};
    border-bottom: ${props => props.theme.colors.capsuleGreen60} ${props => props.theme.space['0.2']} solid !important;
  }

  & input[type='search'] {
    appearance: none;
  }
`;

export const StyledSVG = styled(InlineSVG)`
  svg {
    width: ${props => props.theme.space['2.0']} !important;
    height: ${props => props.theme.space['2.0']} !important;
  }
`;

export const SearchInput = styled.input`
  background: transparent;
  border: none;
  width: 100%;

  color: ${props => props.theme.colors.capsuleBlue50} !important;
  font-family: ${props => props.theme.fonts.circular} !important;
  font-size: ${props => props.theme.fontSizes.body} !important;

  padding-left: ${props => props.theme.space['1.0']} !important;
  padding-right: ${props => props.theme.space.none} !important;
  padding-bottom: 1rem;

  ::placeholder {
    color: ${props => props.theme.colors.capsuleGreen60} !important;
    font-family: ${props => props.theme.fonts.circular} !important;
    font-size: ${props => props.theme.fontSizes.body} !important;
  }

  &:focus {
    outline: none;
  }
`;
